import { render, staticRenderFns } from "./automation.vue?vue&type=template&id=aec5e4d4&scoped=true&lang=pug&"
import script from "./automation.vue?vue&type=script&lang=coffee&"
export * from "./automation.vue?vue&type=script&lang=coffee&"
import style0 from "./automation.vue?vue&type=style&index=0&id=aec5e4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec5e4d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/buildhome/repo/components/loading.vue').default,Notifications: require('/opt/buildhome/repo/components/notifications/notifications.vue').default,AutomationNav: require('/opt/buildhome/repo/components/automation/automation-nav.vue').default})
